import React, { useEffect, useState, useContext, useMemo } from "react";
import SideBar from "components/common/SideBar/SideBarNew";
import Header from "components/common/Header/Header";
import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import CaseNotesTable from "./caseNotesReportTable";
import FundingReportTable from "./fundingReportTable";
import SelectOption from "components/common/Select/Select";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import SelectBox from "components/common/DropDownWithIocnsForPrint copy/DropDown";
import PaginationComponent from "components/common/Pagination/index";
import {
  COS_BREADCRUMB,
  COS_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import {
  getParticipantLabel,
  getLineItemLabel,
  REPORTING_LIMIT,
} from "Constants/constant";
import api from "store/services/cos.services";
import { LoginContext } from "helpers/LoginContext";
import { trackTabSwitch } from "Utils/trackTabSwitch";
import { trackFeatureUse } from "Utils/trackFeatureUse";
import CustomButton from "components/common/Button/CustomButton";
import { BsFilterCircle } from "react-icons/bs";
import { FiDelete } from "react-icons/fi";

const HOURS_TYPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "billable_hours", label: "Billable" },
  { value: "non_billable_hour", label: "Non-Billable" },
];

const ALL_OPTION = { label: "All", value: "all" };

const sortOptionsByLabel = (list) =>
  [...(list || [])]
    .filter((item) => item?.value !== "all")
    .sort((a, b) =>
      String(a.label || "").localeCompare(String(b.label || ""), undefined, {
        sensitivity: "base",
      })
    );

const ReportingMainPage = (props) => {
  const {
    tableDataOfCaseNotesForReporting,
    tableDataForReporting,
    tableDataForReportingLoading,
    getTableDataForReporting,
    supportCoordinator,
    getSupportCoordinatoreList,
    getClientList,
    clientsList,
    caseNotesReportingPaginationMeta,
    settings,
  } = props;

  const participantLabel = getParticipantLabel(settings?.care_sector, false);
  const participantNameLabel = participantLabel + " Name";
  const lineItemLabel = getLineItemLabel(settings?.care_sector);

  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);

  const [serviceContract, setserviceContract] = useState();
  const [selectedClient, setSelectedClient] = useState();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [deliveredFromDate, setDeliveredFromDate] = useState(null);
  const [deliveredToDate, setDeliveredToDate] = useState(null);
  const [report, setReport] = useState("funding");
  const [hoursType, setHoursType] = useState(HOURS_TYPE_OPTIONS[0]);
  const [loading, setIsLoading] = useState(false);
  const [caseNotesPage, setCaseNotesPage] = useState(1);

  useEffect(() => {
    getClientList();
    getSupportCoordinatoreList();
  }, []);

  useEffect(() => {
    setCaseNotesPage(1);
    setSelectedClient(null);
    setserviceContract(null);
    setFromDate(null);
    setToDate(null);
    setDeliveredFromDate(null);
    setDeliveredToDate(null);
    setHoursType(HOURS_TYPE_OPTIONS[0]);
    searchFilterDataRequest(true);
  }, [report]);

  const searchFilterDataRequest = (isClearAll = false, pageNum) => {
    const payload = {
      cos_id: isClearAll ? "all" : serviceContract ? serviceContract.value : "all",
      pt_id: isClearAll ? "all" : selectedClient ? selectedClient.value : "all",
      from_date: isClearAll ? "all" : fromDate ? fromDate : "all",
      to_date: isClearAll ? "all" : toDate ? toDate : "all",
      delivered_date_from: isClearAll ? "all" : deliveredFromDate || "all",
      delivered_date_to: isClearAll ? "all" : deliveredToDate || "all",
      type: report,
    };
    if (report === "case-notes") {
      payload.bill_types = isClearAll
        ? "all"
        : hoursType?.value || "all";
      payload.page = pageNum ?? (isClearAll ? 1 : caseNotesPage);
      payload.per_page = REPORTING_LIMIT;
    }
    getTableDataForReporting(payload);
  };

  const handleCaseNotesPagination = (newPage) => {
    setCaseNotesPage(newPage);
    searchFilterDataRequest(false, newPage);
  };

  const fetchReport = async (data) => {
    try {
      setIsLoading(true);
      const res = await api.getCosFundingReportApi(data);
      if (res) {
        trackFeatureUse("report_export", {
          report_type: data?.type,
          report_format: data?.reportType,
        });
        window.open(res.report.download_url, "_blank");
      }
      setIsLoading(false);
    } catch (Err) {
      setIsLoading(false);
      console.log(Err);
    }
  };

  const handleFileDownLoad = (value) => {
    if (value) {
      fetchReport({
        cos_id: serviceContract ? serviceContract.value : "all",
        pt_id: selectedClient ? selectedClient.value : "all",
        from_date: fromDate ? fromDate : "all",
        to_date: toDate ? toDate : "all",
        delivered_date_from: deliveredFromDate || "all",
        delivered_date_to: deliveredToDate || "all",
        type: report,
        reportType: value,
        ...(report === "case-notes"
          ? { bill_types: hoursType?.value || "all" }
          : {}),
      });
    }
  };

  const participantOptions = useMemo(
    () => [ALL_OPTION, ...sortOptionsByLabel(clientsList)],
    [clientsList]
  );

  const coordinatorOptions = useMemo(
    () => [ALL_OPTION, ...sortOptionsByLabel(supportCoordinator)],
    [supportCoordinator]
  );

  const handleCancelButton = () => {
    setFromDate(null);
    setToDate(null);
  };

  return (
    <div className='min-h-full'>
      <SideBar />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Reporting'
            breadcrumb={
              <Breadcrumb
                pages={COS_BREADCRUMB(COS_BREADCRUMB_PAGES.COS_REPORTING)}
              />
            }
          />
          <div className='w-full'>
            <div className='sm:px-6 lg:px-8 flex d-flex justify-between py-1'>
              <div className='w-[20%]'>
                <label className='text-sm font-medium text-gray-700 text-start'>
                  Select Report
                </label>
                <SelectOption
                  cssClass=''
                  name='report_type'
                  isSearch={false}
                  data={[
                    { value: "funding", label: "Funding" },
                    { value: "case-notes", label: "Case Notes" },
                  ]}
                  selectedOption={[
                    { value: "funding", label: "Funding" },
                    { value: "case-notes", label: "Case Notes" },
                  ].find((x) => x.value === report)}
                  handleChange={(e) => {
                    const fromTab = report;
                    const toTab = e.value;
                    setReport(e.value);
                    try {
                      trackTabSwitch("reporting", fromTab, toTab);
                    } catch (err) {}
                  }}
                  // placeHolder="Select One"
                />
              </div>
              <div className='mt-3'>
                <SelectBox
                  isUserGracePeriodOver={isUserGracePeriodOver}
                  isLoading={loading}
                  setReportType={(e) => {
                    if (isUserGracePeriodOver) {
                      return;
                    }
                    handleFileDownLoad(e);
                  }}
                />
              </div>
            </div>
            <div>
              <div className='sm:px-6 lg:px-8 pt-0 sticky top-[79px] bg-gray-50 z-[5]'>
                <section>
                  <div className='py-4'>
                    <div className='grid gap-x-2 gap-y-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4'>
                      <div className='col-span-1'>
                        <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                          {participantLabel}
                        </label>
                        <SelectOption
                          isDisabled={tableDataForReportingLoading}
                          name='pt_id'
                          isSearch={true}
                          data={participantOptions}
                          selectedOption={selectedClient}
                          handleChange={(e) => {
                            setSelectedClient(e);
                          }}
                          // placeHolder="Participant Name"
                        />
                      </div>
                      <div className='col-span-1'>
                        <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                          Support Coordinators
                        </label>
                        <SelectOption
                          isDisabled={tableDataForReportingLoading}
                          name='contact_type_id'
                          isSearch={true}
                          data={coordinatorOptions}
                          handleChange={(e) => {
                            setserviceContract(e);
                          }}
                          selectedOption={serviceContract}
                          // placeHolder="Services"
                        />
                      </div>
                      <div className='col-span-1'>
                        <label
                          htmlFor='from-date-to-to-date'
                          className='block text-sm font-medium text-gray-700'
                        >
                          Created Date
                        </label>
                        <DateRangePickerNew
                          isDisabled={tableDataForReportingLoading}
                          isClearable={false}
                          handleCancel={() => {
                            setFromDate(null);
                            setToDate(null);
                          }}
                          handleChange={(obj) => {
                            if (obj?.fromDate && obj?.toDate) {
                              setFromDate(obj.fromDate);
                              setToDate(obj.toDate);
                            }
                          }}
                          fromDate={fromDate}
                          toDate={toDate}
                        />
                      </div>
                      <div className='col-span-1'>
                        <label className='block text-sm font-medium text-gray-700'>
                          Delivered Date
                        </label>
                        <DateRangePickerNew
                          isDisabled={tableDataForReportingLoading}
                          isClearable={false}
                          handleCancel={() => {
                            setDeliveredFromDate(null);
                            setDeliveredToDate(null);
                          }}
                          handleChange={(obj) => {
                            if (obj?.fromDate && obj?.toDate) {
                              setDeliveredFromDate(obj.fromDate);
                              setDeliveredToDate(obj.toDate);
                            }
                          }}
                          fromDate={deliveredFromDate}
                          toDate={deliveredToDate}
                        />
                      </div>
                      {report === "case-notes" && (
                        <div className='col-span-1'>
                          <label className='block text-start text-sm font-medium text-gray-700'>
                            Hours Type
                          </label>
                          <SelectOption
                            isDisabled={tableDataForReportingLoading}
                            name='bill_types'
                            isSearch={false}
                            data={HOURS_TYPE_OPTIONS}
                            selectedOption={hoursType}
                            handleChange={(e) => {
                              setHoursType(e);
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div className='mt-4 flex flex-wrap items-center justify-end gap-2 border-t border-gray-200 pt-4'>
                      <CustomButton
                        Icon={<BsFilterCircle className='h-4 w-4' />}
                        clickHandler={() => {
                          if (report === "case-notes") setCaseNotesPage(1);
                          searchFilterDataRequest(false, report === "case-notes" ? 1 : undefined);
                        }}
                        label='Search'
                        showLoading={tableDataForReportingLoading}
                        isDisabled={tableDataForReportingLoading || loading}
                      />
                      <CustomButton
                        variant='secondary'
                        isDisabled={tableDataForReportingLoading || loading}
                        Icon={<FiDelete className='h-4 w-4' />}
                        clickHandler={() => {
                          setSelectedClient(null);
                          setserviceContract(null);
                          setFromDate(null);
                          setToDate(null);
                          setDeliveredFromDate(null);
                          setDeliveredToDate(null);
                          setHoursType(HOURS_TYPE_OPTIONS[0]);
                          searchFilterDataRequest(true);
                        }}
                        label='Clear Filter'
                        cssClass='whitespace-nowrap'
                      />
                    </div>
                  </div>
                </section>
              </div>
              <section className='sm:px-6 lg:px-8 py-4 pt-0'>
                {loading || tableDataForReportingLoading ? (
                  <div
                    className={`flex flex-col w-full min-h-screen bg-gray-50 items-center justify-center`}
                  >
                    <CircularLoader
                      classes='flex justify-center items-center'
                      classloader='loader-l'
                    />
                  </div>
                ) : report === "funding" ? (
                  <FundingReportTable
                    fundingData={tableDataForReporting}
                    participantNameLabel={participantNameLabel}
                  />
                ) : (
                  report === "case-notes" && (
                    <>
                      <CaseNotesTable
                        caseNoteData={tableDataOfCaseNotesForReporting}
                        participantNameLabel={participantNameLabel}
                        lineItemLabel={lineItemLabel}
                      />
                      {tableDataOfCaseNotesForReporting?.length > 0 &&
                        caseNotesReportingPaginationMeta?.total > 0 && (
                          <div className="bg-white sm:px-6 lg:px-8 w-full py-4 sm:py-6 border-t border-gray-200">
                            <PaginationComponent
                              page={caseNotesReportingPaginationMeta.current_page}
                              activeListLength={tableDataOfCaseNotesForReporting}
                              limit={REPORTING_LIMIT}
                              totalList={caseNotesReportingPaginationMeta.total}
                              handlePagination={handleCaseNotesPagination}
                              totalPages={caseNotesReportingPaginationMeta.last_page}
                            />
                          </div>
                        )}
                    </>
                  )
                )}
              </section>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ReportingMainPage;
